// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@conklin/MobiusOverrides/LazyImage";
import { bannerStyles } from "@conklin/Overrides/Widgets/Basic/Banner";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import { createLinkIconStyles, getSystemColor, hideElement, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

bannerStyles.wrapper = {
    ...mergeWithCss(bannerStyles.wrapper, {
        css: css`
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            ${xScreen("lte", "md")} {
                min-height: unset;
            }
        `,
    }),
};

bannerStyles.pictureWrapper = {
    css: css`
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);

        ${LazyImageStyle} {
            width: 100%;
            height: 100%;
            picture {
                display: flex;
                width: 100%;
                flex: 1;
            }
            img {
                flex: 1;
                width: 100%;
                object-fit: cover;
            }
        }
    `,
};

bannerStyles.overlayWrapper = {
    css: css`
        z-index: 1;
        &:has(div:empty) {
            ${hideElement}
        }
    `,
};

bannerStyles.bannerLink = {
    ...createLinkIconStyles(IconArrowRight, "default", "right", true, {
        css: css`
            align-self: flex-start;
        `,
    }),
};

bannerStyles.contentWrapper = {
    css: css`
        padding: 32px 20px 62px;
        ${xScreen("lte", "sm")} {
            padding: 32px 20px;
        }
    `,
};
bannerStyles.heading = {
    forwardAs: "div",
    color: "common.ui1",
    css: css`
        margin-bottom: 16px;
    `,
};
bannerStyles.subHeading = {
    size: 16,
    lineHeight: "26px",
    color: "common.ui1",
    css: css`
        display: flex;
    `,
};
